import { type IColumn, Icon, Tooltip, Typography } from 'shared/ui'
import { type RowNumber } from 'entities/Phone/model/Table/RowNumber'
import styles from './styles.module.scss'

export const phoneCell: IColumn<RowNumber> = {
  field: 'nationalNumber',
  name: 'Number',
  isDisabledChangeVisible: true,
  isSortable: true,
  sortKey: 'number',
  renderRowCell: (row, column, config) => {
    const { disabled } = row
    const { formatted_number, tooltip, lock, is_aircall, address } = row.origin

    return (
      <div className={styles.numberCell}>
        {lock && disabled && (
          <div className={styles.lock}>
            <Tooltip
              label={lock.tooltip}
              placement={'top'}
              PopperProps={{
                popperOptions: {
                  modifiers: [
                    {
                      name: 'preventOverflow',
                      options: {
                        boundary: config.refCell.current,
                      },
                    },
                  ],
                },
              }}
            >
              <Icon className={styles.lock__icon} icon={'lock'} fontSize={20} />
            </Tooltip>
          </div>
        )}

        <div className={styles.content}>
          <div className={styles.row}>
            {formatted_number}
            {tooltip && (
              <Tooltip
                label={<div style={{ wordBreak: 'break-word' }}>{tooltip}</div>}
                placement={'top'}
              >
                <Icon fontSize={14} icon={'question'} color={'var(--content-neutral-primary)'} />
              </Tooltip>
            )}
            {is_aircall ? <Icon icon={'aircall'} /> : undefined}
          </div>
          <Typography ariaLabel={'info'} variant={'body-sm-regular'} color={'tertiary'}>
            {address}
          </Typography>
        </div>
      </div>
    )
  },
}
